<generic-modal #helpSupportModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading>
		<div class="header-wrapper">
			<div class="header-title">
				<h3>Customer Support</h3>
			</div>
			<div class="close-button">
				<button mat-flat-button (click)="onClose()">
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</div>

	</ng-template>
	<ng-template #modalBody>
		<form class="main-form help-request-form" [formGroup]="helpRequestForm">
			<mat-form-field>
				<mat-label>Site</mat-label>
				<mat-select formControlName="accountSiteId">
					<mat-option class="help-request-select-option" *ngFor="let site of sites"
						[value]="site.accountSiteId">
						<div class="site-address">{{site.siteAddress}}</div>
						<div class="site-name">{{site.name}}</div>
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field>
				<mat-label>Issue</mat-label>
				<input matInput formControlName="issue">
			</mat-form-field>
			<mat-form-field>
				<mat-label>Issue Details</mat-label>
				<textarea rows="10" matInput formControlName="issueDetails"></textarea>
			</mat-form-field>
			<input #photosInput hidden="true" type="file" multiple onclick="this.value=null"
				(change)="onPhotoChange($event, photosInput)" [accept]="photoTypes" />
			<div class="photos-wrapper">
				<button mat-flat-button color="primary" (click)="photosInput.click()">
					Choose picture(s)
				</button>
				<div *ngIf="isMaxAllowedPhoto" class="warning-photo-message">
					Please select {{maxAllowedPhotos}} or less pictures.
				</div>
				<div class="photo-item" *ngFor="let photo of helpRequestForm.get('photos').value">
					<div class="photo-name">{{photo.name}}</div>
					<div class="delete-action">
						<button mat-icon-button title="Delete" (click)="onDeletePhoto(photo)">
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</form>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button class="primary" [disabled]="helpRequestForm.invalid || isSaving" (click)="onSave()">Submit</button>
		<button mat-flat-button (click)="onClose()">Cancel</button>
	</ng-template>
</generic-modal>